import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GameProvider } from './context/GameContext';
import GlobalStyles from './styles/GlobalStyles';
import Home from './components/Home';
import NumberQuest from './games/NumberQuest';
import PatternPuzzle from './games/PatternPuzzle';
import SentenceScramble from './games/SentenceScramble';
import PhonicsFactory from './games/PhonicsFactory';
import TimesTablesAdventure from './games/TimesTablesAdventure';
import VocabularyVault from './games/VocabularyVault';
import ComparisonChampions from './games/ComparisonChampions';
import ParentDashboard from './components/ParentDashboard';
import Header from './components/Header';
import Footer from './components/Footer';
import games from './data/games';

function App() {
  return (
    <Router>
      <GameProvider initialGames={games}>
        <GlobalStyles />
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/games/number-quest" element={<NumberQuest />} />
              <Route path="/games/pattern-puzzle" element={<PatternPuzzle />} />
              <Route path="/games/sentence-scramble" element={<SentenceScramble />} />
              <Route path="/games/phonics-factory" element={<PhonicsFactory />} />
              <Route path="/games/times-tables-adventure" element={<TimesTablesAdventure />} />
              <Route path="/games/vocabulary-vault" element={<VocabularyVault />} />
              <Route path="/games/comparison-champions" element={<ComparisonChampions />} />
              <Route path="/parent" element={<ParentDashboard />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </GameProvider>
    </Router>
  );
}

export default App;
